import VerticalLayout from './layouts/Vertical/Vertical';

import NotFound from './pages/errors/NotFound/NotFound';
import PageDashboard from './pages/dashboards/Dashboard/Dashboard';
import PageTypography from './pages/ui/Typography/Typography';
import PageButtons from './pages/ui/Buttons/Buttons';
import PageDropdowns from './pages/ui/Dropdowns/Dropdowns';
import PageAlerts from './pages/ui/Alerts/Alerts';
import PageAvatars from './pages/ui/Avatars/Avatars';
import PageBadges from './pages/ui/Badges/Badges';
import PageCards from './pages/ui/Cards/Cards';
import PageCheckboxes from './pages/ui/Checkboxes/Checkboxes';
import PageCircleProgresses from './pages/ui/CircleProgresses/CircleProgresses';
import PageInputs from './pages/ui/Inputs/Inputs';
import PageLists from './pages/ui/Lists/Lists';
import PageModals from './pages/ui/Modals/Modals';
import PageProgresses from './pages/ui/Progresses/Progresses';
import PageRadioButtons from './pages/ui/RadioButtons/RadioButtons';
import PageRatings from './pages/ui/Ratings/Ratings';
import PageSelects from './pages/ui/Selects/Selects';
import PageSwitchers from './pages/ui/Switchers/Switchers';
import PageTextareas from './pages/ui/Textareas/Textareas';
import PageTags from './pages/ui/Tags/Tags';
import PageAutocomplete from './pages/ui/Autocompletes/Autocompletes';
import PageSliders from './pages/forms/Sliders/Sliders';
import PageDatePickers from './pages/forms/Datepickers/Datepickers';
import PageTimePickers from './pages/forms/Timepickers/Timepickers';
import PageUploads from './pages/forms/Uploads/Uploads';
import PageCascaders from './pages/ui/Cascaders/Cascaders';
import PageSteps from './pages/forms/Steps/Steps';
import PageTimelines from './pages/ui/Timelines/Timelines';
import PagePaginations from './pages/forms/Paginations/Paginations';
import PageFormElements from './pages/forms/Elements/Elements';
import PageFormValidation from './pages/forms/Validations/Validation';
import PageFormLayouts from './pages/forms/Layouts/Layouts';
import PageAnalytics from './pages/dashboards/Analytics/Analytics';
import PageECommerce from './pages/dashboards/eCommerce/eCommerce';
import PageWidgets from './pages/dashboards/Widgets/Widgets';
import ErrorLayout from './layouts/Error/Error';
import InternalError from './pages/errors/InternalError/InternalError';
import ServiceUnavailable from './pages/errors/ServiceUnavailable/ServiceUnavailable';
import Forbidden from './pages/errors/Forbidden/Forbidden';
import PublicLayout from './layouts/Public/Public';
import PageSignIn from './pages/authentifications/SignIn/SignIn';
import PageVerifyAccount from './pages/authentifications/VerifyAccount/VerifyAccount';
import PageResetPassword from './pages/authentifications/ResetPassword/ResetPassword';
import PageSettings from "./pages/Settings/Settings";
import UserLayout from "./layouts/UserLayout/User";
import PageEmailCode from "./pages/authentifications/ResetPassword/ResetPasswordStep2";
import PageNewPassword from "./pages/authentifications/ResetPassword/ResetPasswordStep3";
import PageEditAccount from './pages/Users/EditAccount/EditAccount';
import PageEditCompany from './pages/Company/EditCompany/EditCompany';
import PageImportCompanies from './pages/Company/ImportCompanies/ImportCompanies';
import PageQuickAdd from './pages/Users/ImportUsers/QuickAdd';
import PageViewProfile from './pages/ViewProfile/ViewProfile';
import UserList from './pages/Users/UserList/UserList';
import ImportUsers from './pages/Users/ImportUsers/ImportUsers';
import CompanyList from './pages/Company/CompanyList/CompanyList';
import PageChangePassword from './pages/ChangePassword/ChangePassword';

export interface IRoute {
  path: string;
  component: any;
  exact?: boolean;
  children?: IRoute[];
}

export const defaultRoutes: IRoute[] = [
  {
    path: '/404',
    component: NotFound
  },
  {
    path: '/dashboard',
    component: PageDashboard
  },
  {
    path: '/typography',
    component: PageTypography
  },
  {
    path: '/buttons',
    component: PageButtons
  },
  {
    path: '/dropdowns',
    component: PageDropdowns
  },
  {
    path: '/alerts',
    component: PageAlerts
  },
  {
    path: '/avatars',
    component: PageAvatars
  },
  {
    path: '/badges',
    component: PageBadges
  },
  {
    path: '/cards',
    component: PageCards
  },
  {
    path: '/checkboxes',
    component: PageCheckboxes
  },
  {
    path: '/circular-progresses',
    component: PageCircleProgresses
  },
  {
    path: '/inputs',
    component: PageInputs
  },
  {
    path: '/lists',
    component: PageLists
  },
  {
    path: '/modals',
    component: PageModals
  },
  {
    path: '/progresses',
    component: PageProgresses
  },
  {
    path: '/radio-buttons',
    component: PageRadioButtons
  },
  {
    path: '/ratings',
    component: PageRatings
  },
  {
    path: '/selects',
    component: PageSelects
  },
  {
    path: '/sliders',
    component: PageSliders
  },
  {
    path: '/switchers',
    component: PageSwitchers
  },
  {
    path: '/tags',
    component: PageTags
  },
  {
    path: '/textareas',
    component: PageTextareas
  },
  {
    path: '/autocompletes',
    component: PageAutocomplete
  },
  {
    path: '/date-picker',
    component: PageDatePickers
  },
  {
    path: '/time-picker',
    component: PageTimePickers
  },
  {
    path: '/upload',
    component: PageUploads
  },
  {
    path: '/cascaders',
    component: PageCascaders
  },
  {
    path: '/steps',
    component: PageSteps
  },
  {
    path: '/timelines',
    component: PageTimelines
  },
  {
    path: '/paginations',
    component: PagePaginations
  },
  {
    path: '/form-elements',
    component: PageFormElements
  },
  {
    path: '/form-validation',
    component: PageFormValidation
  },
  {
    path: '/form-layouts',
    component: PageFormLayouts
  },
  {
    path: '/analytics',
    component: PageAnalytics
  },
  {
    path: '/e-commerce',
    component: PageECommerce
  },
  {
    path: '/widgets',
    component: PageWidgets
  },
  {
    path: '/edit-account/:id',
    component: PageEditAccount
  },
  {
    path: '/edit-company/:id',
    component: PageEditCompany
  },
  {
    path: '/user-list',
    component: UserList
  },
  {
    path: '/import-users',
    component: ImportUsers
  },
  {
    path:'/company-list',
    component: CompanyList
  },
  {
    path:'/import-companies',
    component: PageImportCompanies
  },
  {
    path:'/quick-add',
    component: PageQuickAdd
  },
  {
    path:'/settings',
    component: PageSettings
  },
  {
    path: '/change-password',
    component: PageChangePassword
  }
];

export const userRoutes: IRoute[] = [
  {
    path: '/:id',
    component: PageViewProfile,
  },
];

export const publicRoutes: IRoute[] = [
  {
    path: '/sign-in',
    component: PageSignIn
  },
  {
    path: '/verify-account',
    component: PageVerifyAccount
  },
  {
    path: '/forgot-password',
    component: PageResetPassword
  },
  {
    path: '/email-code',
    component: PageEmailCode
  },
  {
    path: '/new-password/:id',
    component: PageNewPassword
  }
];

export const errorRoutes: IRoute[] = [
  {
    path: '/404',
    component: NotFound
  },
  {
    path: '/500',
    component: InternalError
  },
  {
    path: '/503',
    component: ServiceUnavailable
  },
  {
    path: '/505',
    component: Forbidden
  }
];

export const routes: IRoute[] = [
  {
    path: '/vertical',
    component: VerticalLayout,
    children: defaultRoutes
  },
  {
    path: '/error',
    component: ErrorLayout,
    children: errorRoutes
  },
  {
    path:'/user',
    component: UserLayout,
    children: userRoutes
  },
  {
    path: '/public',
    component: PublicLayout,
    children: publicRoutes
  }
];
